export default __webpack_public_path__ + "static/media/User_scan_duotone.2de6d086.svg";